<template>
  <div
    @click="select"
    class="flex column day_wrapper py2 px1 center_text"
  >
    <div
      class="day"
      :class="{selected: isSelected}"
    >{{ dayData.dayNumber || '' }}</div>

  <circle-button
      v-if="dayData.dayNumber"
      size="8"
      :color="dotColor"
      class="mt1"
      style="border: none"
      fill
    ></circle-button>
  </div>
</template>

<script>
export default {
  name: 'day-in-calendar',

  props: {
    dayData: Object,
    value: Object,
  },

  computed: {
    isSelected() {
      return this.value.dayNumber === this.dayData.dayNumber && this.dayData.isSelectable;
    },
    dotColor() {
      return this.dayData.isSelectable && !this.isSelected ? '#00C853' : '';
    },
  },

  methods: {
    select() {
      if (this.dayData.isSelectable) {
        this.$emit('input', this.isSelected ? {} : this.dayData);
      }
    },
  },
};
</script>

<style lang="scss">
  .day_wrapper {
    height: 40px;
  }

  .day {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    height: 12px;
    width: 12px;
    padding: 6px;

    &.selected {
      background-color: $color_good;
      color: white;
    }
  }
</style>
